import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getStatementsCount } from '../../../features/account/account.slice';
import { useTitle } from '../../../hooks/titleProvider';
import AccountInfoCard from './components/accountInfoCard';
import AccountSummaryCard from './components/accountSummaryCard';
import AccountTabs from './components/accountTabs';
import Statements from './components/statements';

function AccountView(props) {
  const { accountNumber } = useParams();
  const dispatch = useDispatch();
  const balances = useSelector((state) => state.account.balances);
  const statementCount = useSelector((state) => state.account.statementsCount);
  const loadingStatementsCount = useSelector((state) => state.account.loadingStatementsCount);
  const [account, setAccount] = useState(null);

  const fees = useSelector((state) => state.transaction.fees);

  const { setTitle } = useTitle();

  const summaryComponent = useCallback(() => {
    if (account) {
      switch (account.administrator) {
        default:
          return <AccountSummaryCard account={account} accountNumber={accountNumber} />;
      }
    }
    return null;
  }, [account, accountNumber]);

  const tabs = useMemo(() => {
    const tabsArray = [
      {
        title: 'Summary',
        content: summaryComponent()
      }
      // {
      //   title: 'Transactions',
      //   content: (
      //     <AccountTransactionsCard account={account} accountNumber={accountNumber} fees={fees} />
      //   )
      // }
    ];

    // If statements are available, add the Statements tab
    if (account && account.hasStatements) {
      tabsArray.push({
        title: 'Statements',
        content: <Statements account={account} accountNumber={accountNumber} />
      });
    }

    return tabsArray;
  }, [account, accountNumber, statementCount, summaryComponent, loadingStatementsCount]);

  useEffect(() => {
    dispatch(getStatementsCount(accountNumber));
  }, [dispatch, accountNumber, statementCount]);

  useEffect(() => {
    if (balances && accountNumber) {
      setAccount(balances.find((balance) => balance.accountNumber === accountNumber));
    }
  }, [balances, accountNumber]);

  useEffect(() => {
    if (account) {
      setTitle(account.product);
    }
  }, [account, setTitle]);

  return (
    account && (
      <AccountTabs tabs={tabs}>
        <AccountInfoCard account={account} />
      </AccountTabs>
    )
  );
}

export default AccountView;
